export default "__VITE_ASSET__0c9f3564__"